import { Progress, ProgressProps } from 'antd';
import clsx from 'clsx';
import { IconBaseProps } from 'react-icons/lib';
import { RiFlashlightFill } from 'react-icons/ri';
import { getStrokeColor, progressColor } from './app-progressbar-circle.utils';

type Props = {
  percent: number;
  iconProps?: IconBaseProps;
} & ProgressProps;

export function AppProgressBarCircle(props: Props) {
  const { percent, iconProps = {}, size = 24, ...restProps } = props;
  const strokeColor = getStrokeColor(percent);

  return (
    <Progress
      type="circle"
      percent={percent}
      size={size}
      strokeWidth={15}
      format={() => <RiFlashlightFill size={14} color="white" className="m-auto" {...iconProps} />}
      trailColor="var(--color-gray-400)"
      strokeColor={
        strokeColor == 'green'
          ? progressColor.green
          : strokeColor === 'yellow'
            ? progressColor.yellow
            : progressColor.red
      }
      className={clsx('app-progress [&>.ant-progress-inner]:-translate-y-0.5', strokeColor)}
      style={{
        height: size as number,
      }}
      {...restProps}
    />
  );
}
